import qs from "qs";
import { ClientFilter } from "../types/ClientFilterTypes";

export const parseFilter = (search: string): ClientFilter => {
  const loaded = qs.parse(search, { ignoreQueryPrefix: true });
  return {
    tableFilter: (loaded.tableFilter as string) || "",
    filter: (loaded.filter as string) || "",
    state: (loaded.state as string) || "",
    validFrom: (loaded.validFrom as string) || "",
    validTo: (loaded.validTo as string) || "",
    ids: (loaded.ids as string[]) || null,
    idTo: (loaded.idTo as string) || "",
    idFrom: (loaded.idFrom as string) || "",
    myClients: loaded.myClients === "true",
    responsibleUser: (loaded.responsibleUser as string) || "",
  };
};

export const defaultFilter: ClientFilter = {
  tableFilter: "",
  state: "",
  filter: "",
  idTo: "",
  idFrom: "",
  validFrom: "",
  validTo: "",
  ids: null,
  myClients: false,
  responsibleUser: "",
}; 